import {TaxiMessage} from "./taxi-message";

export class SearchPaused implements TaxiMessage {
  constructor(public draftId: number) {}

  getDraftId(): number {
    return this.draftId;
  }

}
